import React, { useEffect, useState } from 'react';
import { contentsAPI } from '@/utils/contentsApi';
import { cn } from '@/utils/cn';
import { usePathname } from 'next/navigation';
import DynamicSectionTitle from '../Typography/DynamicSectionTitle';
import OngoingCampaignSlider from '../Slider/OngoingCampaignSlider';

function OngoingCampaignSection({ section }) {
  const pathname = usePathname();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const contentsData = {
          sectionId: section?.id,
          contentType: section?.content_type,
        };
        const response = await contentsAPI(contentsData);
        setData([...response]);
        setLoading(false);
      } catch (err) {
        console.warn('Error fetching data:', err);
      }
    };

    setLoading(true);
    fetchData();
  }, []);

  if (Array.isArray(data) && data?.length === 0) {
    return null;
  }

  return (
    <div className="ongoing-campaign-section">
      <div className="mt-16 mb-24 lg:mb-40">
        <div className="container mx-auto">
          <DynamicSectionTitle
            text="Ongoing Campaigns"
            className={cn({
              'text-center': pathname === '/',
            })}
          />
        </div>
        <OngoingCampaignSlider
          data={data}
          sectionData={section}
          loading={loading}
        />
      </div>
    </div>
  );
}

export default OngoingCampaignSection;
